module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../babel-loader/lib/index.js??ref--0!./full-dynamic-stock-chart.js"));
	}, "dynamic-stock-chart");
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/bundle-loader?lazy&name=dynamic-stock-chart!../node_modules/@cube/finance-components/src/components/dynamic-stock-chart/full-dynamic-stock-chart.js
// module id = 824
// module chunks = 0